import { lazy } from 'react';

const Affiliate = lazy(() => import(/* webpackChunkName: "affiliate" */ './affiliate.js'));
export default Affiliate;
